import { Component, Vue } from "vue-property-decorator";

@Component
export default class CostBearerMixin extends Vue {
  public get hasNotPermissionWrite(): boolean {
    return !this.$can(this.MODULE_COST_BEARERS_WRITE);
  }
}
